/**
 * @module events/hooks/preventDefault
 */

/**
 * Prevents the default behavior of an event
 * @param {Event} event
 */
export default (
  event
) => {
  event.preventDefault()
}
